<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <div :class="$style.column">{{ project.counterparty?.name }}</div>
      <div :class="$style.column">{{ project.name }}</div>
      <div :class="$style.column">
        {{ project.started_at.substr(0, 10).split("-").reverse().join(".") }}
      </div>
      <div :class="$style.column">
        {{ project.ended_at.substr(0, 10).split("-").reverse().join(".") }}
      </div>
      <div :class="$style.column">{{ parseFloat(project.cost) }} $</div>
      <div :class="$style.column">{{ parseFloat(project.readiness) }} %</div>
    </div>
    <div :class="$style.edit">
      <img
        v-if="!isSettingsOpen"
        @click.stop="isSettingsOpen = !isSettingsOpen"
        src="/icons/ellipsis.svg"
        alt=""
      />
      <img
        v-else
        @click.stop="isSettingsOpen = !isSettingsOpen"
        src="/icons/medium-cross.svg"
        alt=""
      />
      <div v-if="isSettingsOpen" :class="$style.settings">
        <div @click.stop="edit">
          <img src="/icons/edit-black.svg" alt="" />Редактировать
        </div>
        <div @click.stop="remove" :class="$style.red">
          <img src="/icons/delete.svg" alt="" />Удалить
        </div>
      </div>
    </div>
  </div>
  <!-- <Transition>
    <ItemInfo v-if="isInfoOpen" :project="project" />
  </Transition> -->
</template>

<script>
import ItemInfo from "./ItemInfo.vue";
export default {
  data() {
    return {
      isInfoOpen: false,
      isSettingsOpen: false,
    };
  },
  props: {
    project: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ItemInfo,
  },
  methods: {
    async remove() {
      await this.$store.dispatch("deleteProject", this.project.slug);
      await this.$store.dispatch("getProjects", {});
      this.isSettingsOpen = false;
    },
    edit() {
      this.$router.push(`/project/${this.project.slug}`);
    },
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  background-color: $bg-secondary;
  padding: 1.5rem;
  border-bottom: 1px solid $bg-separator;
  @include Body1;
  .date {
    flex: 0 0 5rem;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1 auto;
    .column {
      min-width: 9.5rem;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      &:last-child {
        min-width: none;
        width: 9.5rem;
      }
      &.empty {
        color: $red;
      }
      .dot {
        width: 0.5rem;
        height: 0.5rem;
        flex: 0 0 0.5rem;
        border-radius: 50%;
        &.orange {
          background-color: $orange;
        }
        &.grey {
          background-color: $t-secondary;
        }
        &.green {
          background-color: $main-green;
        }
        &.purple {
          background-color: $purple;
        }
        &.blue {
          background-color: $blue-primary;
        }
        &.red {
          background-color: $red-primary;
        }
      }
    }
  }

  .edit {
    width: 1.5rem;
    cursor: pointer;
    position: relative;
    .settings {
      width: 15rem;
      position: absolute;
      top: 0;
      right: 2.5rem;
      background-color: $bg-secondary;
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      div {
        display: flex;
        gap: 0.5rem;
        align-items: center;
        @include Subtitle;
        cursor: pointer;
        padding: 0.5rem 1rem;
        border-bottom: 1px solid $bg-separator;
        &.red {
          color: $red;
          border-bottom: none;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
  max-height: 3000px;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
